import * as React from "react";

function CloseCircleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props, {
    style: Object.assign({
      verticalAlign: '-0.125em'
    }, props.style),
    className: ['antd-mobile-icon', props.className].filter(Boolean).join(' ')
  }), /*#__PURE__*/React.createElement("g", {
    id: "CloseCircleOutline-CloseCircleOutline",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CloseCircleOutline-\u7F16\u7EC4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "CloseCircleOutline-\u77E9\u5F62",
    fill: "#FFFFFF",
    opacity: 0,
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,2 C36.1502645,2 46,11.8497355 46,24 C46,36.1502645 36.1502645,46 24,46 C11.8497355,46 2,36.1502645 2,24 C2,11.8497355 11.8497355,2 24,2 Z M24,5 C13.5065898,5 5,13.5065898 5,24 C5,34.4934102 13.5065898,43 24,43 C34.4934102,43 43,34.4934102 43,24 C43,13.5065898 34.4934102,5 24,5 Z M18.3750018,16.1171551 L23.9998449,21.7419127 L23.9998449,21.7419127 L29.624688,16.1171551 C29.6997023,16.0421419 29.801443,16 29.9075285,16 L33.0200651,16 C33.240979,16 33.4200651,16.1790861 33.4200651,16.4 C33.4200651,16.5060962 33.3779147,16.6078461 33.3028882,16.6828623 L26.1208449,23.8639127 L26.1208449,23.8639127 L33.5750057,31.3171396 C33.7312252,31.4733395 33.731241,31.7266055 33.5750411,31.882825 C33.5000251,31.9578504 33.398276,32 33.2921807,32 L30.1796562,32 C30.0735583,32 29.9718069,31.9578483 29.8967904,31.8828197 L23.9998449,25.9849127 L23.9998449,25.9849127 L18.1011057,31.8828617 C18.0260927,31.9578646 17.9243593,32 17.8182819,32 L14.7076208,32 C14.4867069,32 14.3076208,31.8209139 14.3076208,31.6 C14.3076208,31.4939151 14.3497622,31.3921749 14.4247747,31.3171607 L21.8778449,23.8639127 L21.8778449,23.8639127 L14.6966968,16.6828443 C14.5404862,16.5266354 14.5404848,16.2733694 14.6966936,16.1171589 C14.7717083,16.0421433 14.8734505,16 14.9795379,16 L18.0921612,16 C18.1982468,16 18.2999874,16.0421419 18.3750018,16.1171551 Z",
    id: "CloseCircleOutline-\u5F62\u72B6",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}

export default CloseCircleOutline;